import { HmrcDataToggleTooltip } from './hmrcDataToggle.type';

const isNonEmptyString = (value: unknown): value is string => typeof value === 'string' && value.trim() !== '';

const isHttpsUrl = (value: string) => {
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
};

// The payload is edited by hand in PostHog, so anything malformed returns null and the tooltip is not shown
export default function parseTooltipPayload(payload: unknown): HmrcDataToggleTooltip | null {
  if (typeof payload !== 'object' || payload === null) return null;

  const { text, linkText, link } = payload as Record<string, unknown>;
  const isTextValid = Array.isArray(text) && text.length > 0 && text.every(isNonEmptyString);
  if (!isTextValid || !isNonEmptyString(linkText) || !isNonEmptyString(link) || !isHttpsUrl(link)) return null;

  return { text, linkText, link };
}
